<template>
  <div class="app-container app-page">
    <van-nav-bar :title="this.lottery.name" class="app-nav-bar">
      <template #left>
        <van-icon name="arrow-left" color="#fff" @click="back()" />
      </template>
           <template #right>
            <van-icon @click="$router.push({ path: '/wallet/game-records' })" name="todo-list-o" color="#ffffff" />
           </template>
    </van-nav-bar>
    <div class="app-record">
      <div class="lottery-page__period">
        <van-image class="app-cover" :src="this.lottery.ico">
          <template v-slot:loading>
            <van-loading type="spinner" />
          </template>
        </van-image>

        <span class="app-period-number">{{ this.lottery.next_expect }}{{$t("期")}}</span>
        <div class="lottery-page__next-number">
          <!-- <span>{{this.lottery.next_expect}}</span> -->
          <template v-if="time !== null">

            <van-count-down :time="time" @finish="check()" />
          </template>
        </div>

      </div>
      <div class="app-linear-gradient"
        style="background: linear-gradient(to right, rgba(126, 86, 120, 0), rgb(230, 195, 161), rgba(126, 86, 120, 0));">
      </div>
      <div class="app-recent">
        <div class="app-dice-ball app-left">

          <div>
            <div style="font-weight: bold;">

              {{ this.lottery.now_expect }}
            </div>
            <div style="text-align: center;margin-top: 10px;">{{ $t("投票结果") }}</div>
          </div>
        </div>
        <div style="flex: 1;"></div>

        <div style="margin-right: 10px;">


          <div class="app-res-des middle lottery-page__lottery-number">{{ this.lottery.one }}</div>
          <div class="app-res-des middle lottery-page__lottery-number" style="margin-bottom: 0;">{{ this.lottery.two }}</div>
        </div>
        <van-icon name="arrow-down" :class="{ 'is-expanded': active, 'is-collapsed': !active }"
          @click="active ? active = false : active = true" />
      </div>
    </div>
    <div class="history_popup"></div>
    <div class="app-wrapper">
      <div class="lottery-page__options-bar">
        <div class="lottery-page__game">
       
          <div class="app-linear-gradient"
            style="background: linear-gradient(to right, rgba(126, 86, 120, 0), rgb(230, 195, 161), rgba(126, 86, 120, 0));">
          </div>
          <div class="lottery-page__bet-option-grid">
            <div class="lottery-page__rectangle large" :class="{ 'is-active': choose[v.type] }" v-for="(v, key) in lottery_peilv_list"
              :key="key" @click="choosePlay(v.type, v.name);">
              <div class="app-wrapper" :style="{ background: v.color || '#2e3846' }">
                <div class="app-content">
                  <p class="lottery-page__name-text large">{{ v.name }}</p>
                  <p class="lottery-page__odd-text large" v-if="$store.getters.getBaseInfo.close_number == 0">{{ v.proportion }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="lottery-page__bottom-bar">
        <div class="lottery-page__bar">
          <div class="app-left">
            <div class="app-item" @click="shopping ? shopping = false : shopping = true">
              <van-icon name="cart-o" class="lottery-page__cart-icon" />
              <!-- <span class="app-text">{{ $t("reservation.task_list") }}</span> -->
            </div>
            <div class="app-line"></div>
          </div>
          <div class="lottery-page__mid">
            <!-- <div><span class="app-text">{{ $t("reservation.available_balance") }}</span></div> -->
            <div><span class="app-text num">{{ this.userInfo.money }}</span>
              <span class="app-text">{{ $t("reservation.unit") }}</span>
            </div>

          </div>
          <div class="app-right"  style="background: #f43443;" @click="jiesuan()">
            {{ $t("reservation.submit") }}
          </div>
        </div>
        <div class="app-wrapper" :class="{ 'is-active': shopping }">
          <div class="app-item">
            <span class="app-label">{{ $t("reservation.curr_choose") }}：</span>
            <div class="lottery-page__bet-number">{{ this.shopchoose }}</div>
            <van-icon name="arrow-down" :class="{ 'is-expanded': !shopping, 'is-collapsed': shopping }"
              @click="shopping ? shopping = false : shopping = true" />
          </div>
          <div class="app-item">
            <span class="app-label">{{ $t("reservation.per_price") }}：</span>
            <div class="lottery-page__amount-wrapper">
              <van-field v-model="money" type="digit" :placeholder="$t('reservation.price_place')" />
              <span class="app-label">{{ $t("reservation.unit") }}</span>
            </div>
          </div>
          <div class="app-item">
            <div class="lottery-page__part">
              <span>{{ $t("reservation.total") }}</span>
              <span class="app-number">{{ this.formData.length }}</span>
              <span>{{ $t("reservation.note") }}</span>
            </div>
            <div class="lottery-page__part">
              <span>{{$t("全部的")}}</span>
              <span class="app-number">{{ this.formData.length * this.money }}</span>
              <span>{{ $t("reservation.unit") }}</span>
            </div>

          </div>
        </div>
      </div>
      <van-popup v-model="jiesuanpage" get-container="body">
        <div class="lottery-page__confirm-order-modal">
          <div class="lottery-page__head van-hairline--bottom">
            <p class="app-text">{{ $t("reservation.task_list") }}</p>
          </div>
          <ui class="app-list">
            <li v-for="(v, key) in formData" :key="key" class="lottery-page__lise-item van-hairline--bottom">
              <div class="app-main">
                <p class="lottery-page__bet-name">{{ v.name }}</p>
                <p class="lottery-page__detail-text">1{{ $t("reservation.note") }}X{{ money }}{{ $t("reservation.unit") }}={{ money
                }}{{ $t("reservation.unit") }}</p>
              </div>
              <van-icon @click="clearChooes(v.type)" name="close" />
            </li>
          </ui>
          <div class="lottery-page__sub-bar">
            <van-button class="app-item cancel-btn" type="default" @click="allClear()">{{ $t("reservation.clear_order")
            }}</van-button>
            <van-button class="app-item app-sub-btn" :disabled="isDisabled" type="default" @click="doSub">{{
              $t("reservation.submit") }}</van-button>
          </div>
        </div>
      </van-popup>
      <van-popup v-model="active" position="top" :style="{ height: '70%' }">
        <van-pull-refresh v-model="isLoading" @refresh="onRefresh" :pulling-text="$t('refresh.pulling')"
          :loosing-text="$t('refresh.loosing')" :loading-text="$t('refresh.loading')">
          <div class="app-wrapper">
            <div class="app-item">
              <div class="app-left lottery-page__font-weight">{{ $t("reservation.num") }}</div>
              <div class="app-right lottery-page__font-weight">{{ $t("reservation.win_num") }}</div>
            </div>
            <div class="app-item" v-for="(v, key) in lottery_list" :key="key">
              <div class="app-left lottery-page__font-weight">{{ v.expect }}</div>
              <div class="app-right lottery-page__font-weight">
                <div class="app-dice-ball app-left" style="justify-content: center;width: 100%;"
                  :style="{ 'margin-left': $store.getters.getBaseInfo.close_number == 1 ? '' : '6px' }">
                  <template v-if="$store.getters.getBaseInfo.close_number == 0">
                    <van-image class="app-res-img" :src="'/img/lottery/shaizi/' + v.opencode[0] + '.png?v=3'">
                      <template v-slot:loading>
                        <van-loading type="spinner" />
                      </template>
                    </van-image>
                    <van-image class="app-res-img" :src="'/img/lottery/shaizi/' + v.opencode[1] + '.png?v=3'">
                      <template v-slot:loading>
                        <van-loading type="spinner" />
                      </template>
                    </van-image>
                    <van-image class="app-res-img" :src="'/img/lottery/shaizi/' + v.opencode[2] + '.png?v=3'">
                      <template v-slot:loading>
                        <van-loading type="spinner" />
                      </template>
                    </van-image>
                    <span class="app-res-des middle">{{ v.opencode[0] + v.opencode[1] + v.opencode[2] }}</span>
                  </template>
                  <div style="display: flex;">

                    <div class="app-res-des middle lottery-page__lottery-number">{{ v.one }}</div>
                    <div class="app-res-des middle lottery-page__lottery-number">{{ v.two }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </van-pull-refresh>
      </van-popup>
    </div>
  </div>
</template>

<script>
// var time;
// var count = 0;
export default {
  data() {
    return {
      jiesuanpage: false,
      choose: {
        "bi": false,
        "sm": false,
        "si": false,
        "do": false,
        "3": false,
        "4": false,
        "5": false,
        "6": false,
        "7": false,
        "8": false,
        "9": false,
        "10": false,
        "11": false,
        "12": false,
        "13": false,
        "14": false,
        "15": false,
        "16": false,
        "17": false,
        "18": false,
      },
      playgame: false,
      shopping: false,
      isLoading: false,
      play: {},
      lottery_peilv_list: {},
      lottery_list: {},
      active: false,
      userInfo: {},
      lottery: {},
      shanzi_1: "0",
      shanzi_2: "0",
      shanzi_3: "0",
      sum: 0,
      size: "",
      double: "",
      time: null,
      shopchoose: this.$t("reservation.no_choose"),
      gameitem: "",
      formData: [],
      money: "",
      isDisabled: false
    };
  },
  methods: {
    back() {
      return window.history.back();
    },
    doSub() {
      if (this.money === "0") {
        this.$toast(this.$t("reservation.money_err"));
        return false;
      }
      if (this.formData.length === 0) {
        this.$toast(this.$t("reservation.choose_num"));
        return false;
      } else if (this.money === "") {
        this.$toast(this.$t("reservation.price_place"));
        return false;
      } else {
        if (this.userInfo.money - (this.money * this.formData.length) < 0) {
          this.$toast(this.$t("reservation.balance_enough"));
          return false;
        } else {
          if (this.isDisabled) return
          this.isDisabled = true
          this.$http({
            method: 'post',
            data: {
              item: this.gameitem,
              money: this.money,
              lid: this.lottery.id,
              mid: this.userInfo.id,
              expect: this.lottery.now_expect
            },
            url: 'game_place_order'
          }).then(res => {
            if (res.code === 200) {
              this.$toast(res.msg);
              this.allClear();
              this.getUserInfo();
            } else if (res.code === 401) {
              this.$toast(res.msg);
            }
            this.isDisabled = false
          })
          return true;
        }
      }
    },
    allClear() {
      for (var i = 0; i < this.formData.length; i++) {
        this.choose[this.formData[i]['type']] = false;
      }
      this.formData.splice(0, this.formData.length);
      this.money = "";
      this.shopchoose = this.$t("reservation.no_choose");
      this.gameitem = "";
      this.shopping = false;
      this.jiesuanpage = false;
    },
    jiesuan() {
      if (this.formData.length === 0) {
        this.$toast(this.$t("reservation.choose_num"));
        return false;
      } else if (this.money === "") {
        this.$toast(this.$t("reservation.price_place"));
        return false;
      }
      else {
        this.jiesuanpage ? this.jiesuanpage = false : this.jiesuanpage = true;
      }

    },
    clearChooes(type) {
      for (var i = 0; i < this.formData.length; i++) {
        if (type === this.formData[i]['type']) {
          this.formData.splice(i, 1)
          this.choose[type] = false;
        }
      }
      if (this.formData.length >= 1) {
        for (var j = 0; j < this.formData.length; j++) {
          if (j === 0) {
            this.shopchoose = this.formData[j]['name'];
            this.gameitem = this.formData[j]['type'];
          } else {
            this.shopchoose += "," + this.formData[j]['name'];
            this.gameitem += "," + this.formData[j]['type'];
          }
        }
      } else {
        this.shopchoose = this.$t("reservation.no_choose");
        this.gameitem = "";
        this.shopping = false;
      }
      if (this.formData.length === 0) {
        this.jiesuanpage = false;
      }
    },
    choosePlay(type, name) {
      const key = String(type);
      const selectedIndex = this.formData.findIndex(
        item => String(item.type) === key
      );

      if (selectedIndex !== -1) {
        // 再次点击已选项：取消选中
        this.formData.splice(selectedIndex, 1);
        this.$set(this.choose, key, false);
      } else {
        // 首次点击：添加选项，兼容后台新增的投注类型
        this.formData.push({ name: name, type: type });
        this.$set(this.choose, key, true);
      }

      if (this.formData.length === 1) {
        this.shopping = true;
      }

      if (this.formData.length > 0) {
        this.shopchoose = this.formData.map(item => item.name).join(',');
        this.gameitem = this.formData.map(item => item.type).join(',');
      } else {
        this.shopchoose = this.$t('reservation.no_choose');
        this.gameitem = '';
        this.shopping = false;
      }
    },
    check() {
      if (!localStorage.getItem('token')) {
        this.$router.push({ path: '/auth/login' })
      } else {
        // time = window.setInterval(() => {
        //   setTimeout(()=>{
        //     count++;
        //     if(count > 5){
        //       clearInterval(time);
        //       count = 0;
        //     }
        //   },0)
        // }, 300)

        this.getUserInfo();
        this.getLotteryInfo();
        this.getLotteryList();
      }
    },
    onRefresh() {
      setTimeout(() => {
        this.$toast(this.$t("reservation.refresh"));
        this.getLotteryList();
        this.isLoading = false;
      }, 200);
    },
    getUserInfo() {
      this.$http({
        method: 'get',
        url: 'user_info'
      }).then(res => {
        if (res.code === 200) {
          this.userInfo = res.data;
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      })
    },
    getLotteryPeilv() {
      this.$http({
        method: 'get',
        data: { id: this.$route.query.id },
        url: 'lottery_get_peilv'
      }).then(res => {
        if (res.code === 200) {
          console.log(res.data, 888)
          this.lottery_peilv_list = res.data;
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      })
    },
    getLotteryList() {
      this.$http({
        method: 'get',
        data: { key: this.$route.query.key },
        url: 'lottery_get_one_list'
      }).then(res => {
        if (res.code === 200) {
          this.lottery_list = res.data;
          this.getLotteryPeilv();
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      })
    },
    getLotteryInfo() {
      this.$http({
        method: 'get',
        data: { key: this.$route.query.key },
        url: 'lottery_get_info'
      }).then(res => {
        if (res.code === 200) {
          // if(parseFloat(this.userInfo.money) < parseFloat(res.data.condition)){
          //   this.$toast(this.$t("reservation.contact_admin"));
          //   this.$router.push({path:'/home'})
          //   return false;
          // }
          this.lottery = res.data;
          this.time = res.data.second * 1000;

          if (this.time / 1000 === 59) {
            this.$toast(this.$t("reservation.prize_succ") + this.lottery.now_expect);
          }
          this.shanzi_1 = "/img/lottery/shaizi/" + res.data.opencode[0] + ".png?v=3";
          this.shanzi_2 = "/img/lottery/shaizi/" + res.data.opencode[1] + ".png?v=3";
          this.shanzi_3 = "/img/lottery/shaizi/" + res.data.opencode[2] + ".png?v=3";
          this.sum = res.data.opencode[0] + res.data.opencode[1] + res.data.opencode[2];
          if (this.sum >= 11 && this.sum <= 18) {
            this.size = 'A';
          } else if (this.sum >= 3 && this.sum <= 10) {
            this.size = 'B';
          }
          if (this.sum % 2 === 0) {
            this.double = 'D';
          } else {
            this.double = 'C';
          }
        } else if (res.code === 401) {
          this.$toast({
            message: res.msg,
            duration: 3000
          });
        }
      })

    }
  },
  created() {
    if (!localStorage.getItem('token')) {
      this.$router.push({ path: '/auth/login' })
    } else {
      this.getUserInfo();
      this.getLotteryInfo();
      this.getLotteryList();
    }
  },
  destroyed() {
    // clearInterval(time);
  }
};
</script>

<style lang='less' scoped src="./index.styles.less"></style>
